/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

import { ReactComponent as icAccess } from '../../../../assets/IconsSidebar/ic-access.svg';
import { ReactComponent as icAnnouncements } from '../../../../assets/IconsSidebar/ic-announcements.svg';
import { ReactComponent as icApprovalFlowBlack } from '../../../../assets/IconsSidebar/ic-approval-flow-black.svg';
import { ReactComponent as icApprovalFlowPrimary } from '../../../../assets/IconsSidebar/ic-approval-flow-primary.svg';
import { ReactComponent as icApprovalFlowWhite } from '../../../../assets/IconsSidebar/ic-approval-flow-white.svg';
import { ReactComponent as icApprovalFlow } from '../../../../assets/IconsSidebar/ic-approval-flow.svg';
import { ReactComponent as icAttendance } from '../../../../assets/IconsSidebar/ic-attendance.svg';
import { ReactComponent as icBackUp } from '../../../../assets/IconsSidebar/ic-back-up.svg';
import { ReactComponent as icCafeteria } from '../../../../assets/IconsSidebar/ic-cafeteria.svg';
import { ReactComponent as icCardDesigner } from '../../../../assets/IconsSidebar/ic-card-designer.svg';
import { ReactComponent as icCardManagment } from '../../../../assets/IconsSidebar/ic-card-managment.svg';
import { ReactComponent as icCompany } from '../../../../assets/IconsSidebar/ic-company.svg';
import { ReactComponent as icContractors } from '../../../../assets/IconsSidebar/ic-contractors.svg';
import { ReactComponent as icController } from '../../../../assets/IconsSidebar/ic-controller.svg';
import { ReactComponent as icDeleteRestore } from '../../../../assets/IconsSidebar/ic-delete-restore.svg';
import { ReactComponent as icDepartments } from '../../../../assets/IconsSidebar/ic-departments.svg';
import { ReactComponent as icDevices } from '../../../../assets/IconsSidebar/ic-devices.svg';
import { ReactComponent as icDistributioCenter } from '../../../../assets/IconsSidebar/ic-distributio-center.svg';
import { ReactComponent as icDocumentPanel } from '../../../../assets/IconsSidebar/ic-document-panel.svg';
import { ReactComponent as icEmailServiceSettings } from '../../../../assets/IconsSidebar/ic-email-service-settings.svg';
import { ReactComponent as icEmployees } from '../../../../assets/IconsSidebar/ic-employees.svg';
import { ReactComponent as icEvents } from '../../../../assets/IconsSidebar/ic-events.svg';
import { ReactComponent as icFirstAccess } from '../../../../assets/IconsSidebar/ic-first-access.svg';
import { ReactComponent as icGraphs } from '../../../../assets/IconsSidebar/ic-graphs.svg';
import { ReactComponent as icGuard } from '../../../../assets/IconsSidebar/ic-guard.svg';
import { ReactComponent as icHomeOffice } from '../../../../assets/IconsSidebar/ic-home-office.svg';
import { ReactComponent as icLogs } from '../../../../assets/IconsSidebar/ic-logs.svg';
import { ReactComponent as icManager } from '../../../../assets/IconsSidebar/ic-manager.svg';
import { ReactComponent as icOnBoarding } from '../../../../assets/IconsSidebar/ic-on-boarding.svg';
import { ReactComponent as icPrivilageSettings } from '../../../../assets/IconsSidebar/ic-privilage-settings.svg';
import { ReactComponent as icProfile } from '../../../../assets/IconsSidebar/ic-profile.svg';
import { ReactComponent as icServiceType } from '../../../../assets/IconsSidebar/ic-service-type.svg';
import { ReactComponent as icSupplier } from '../../../../assets/IconsSidebar/ic-supplier.svg';
import { ReactComponent as icSystemSettings } from '../../../../assets/IconsSidebar/ic-system-settings.svg';
import { ReactComponent as icTransportRequest } from '../../../../assets/IconsSidebar/ic-transport-request.svg';
import { ReactComponent as icVehicleFleet } from '../../../../assets/IconsSidebar/ic-vehicle-fleet.svg';
import { ReactComponent as icWorkshipPanel } from '../../../../assets/IconsSidebar/ic-workship-panel.svg';
import { ReactComponent as icDiningManagement } from '../../../../assets/IconsSidebar/ic-dining-management.svg'
import { ReactComponent as icVisitorManagment } from '../../../../assets/IconsSidebar/ic-visitor-managment.svg';
import { ReactComponent as icOutput } from '../../../../assets/IconsSidebar/ic-output.svg';
import { ReactComponent as icReaders } from '../../../../assets/IconsSidebar/ic-readers.svg';
import { ReactComponent as icSios } from '../../../../assets/IconsSidebar/ic-sios.svg';
import { ReactComponent as icInput } from '../../../../assets/IconsSidebar/ic-input.svg';
import { ReactComponent as icAcr } from '../../../../assets/IconsSidebar/ic-acr.svg';
import { ReactComponent as icControllerSubmenu } from '../../../../assets/IconsSidebar/ic-controller-submenu.svg';
import { ReactComponent as icKitchenTickets } from '../../../../assets/IconsSidebar/ic-kitchen-tickets.svg';
import { ReactComponent as icIncomingInvitation } from '../../../../assets/IconsMenuCard/ic-incoming-invitation.svg';
import { ReactComponent as icTraffic } from '../../../../assets/IconsMenuCard/ic-traffic.svg';
import { ReactComponent as icIncomingContractor } from '../../../../assets/IconsSidebar/ic-incoming-contractors.svg';
import { ReactComponent as icCompanyDocumentation } from '../../../../assets/IconsSidebar/ic-company-documentation.svg';
import { ReactComponent as icDeliveredServices } from '../../../../assets/IconsTittles/ic-meal-time.svg';
import { ReactComponent as icEquipmentMaterial } from '../../../../assets/IconsMenuCard/ic-equipment-material.svg';


export const IconsSideBar = {
    icAccess,
    icAnnouncements,
    icApprovalFlowBlack,
    icApprovalFlowPrimary,
    icApprovalFlowWhite,
    icApprovalFlow,
    icAttendance,
    icBackUp,
    icCafeteria,
    icCardDesigner,
    icCardManagment,
    icCompany,
    icContractors,
    icController,
    icDeleteRestore,
    icDepartments,
    icDevices,
    icDistributioCenter,
    icDocumentPanel,
    icEmailServiceSettings,
    icEmployees,
    icEvents,
    icFirstAccess,
    icGraphs,
    icGuard,
    icHomeOffice,
    icLogs,
    icManager,
    icOnBoarding,
    icPrivilageSettings,
    icProfile,
    icServiceType,
    icSupplier,
    icSystemSettings,
    icTransportRequest,
    icVehicleFleet,
    icWorkshipPanel,
    icDiningManagement,
    icVisitorManagment,
    icOutput,
    icReaders,
    icSios,
    icInput,
    icAcr,
    icControllerSubmenu,
    icKitchenTickets,
    icIncomingInvitation,
    icTraffic,
    icIncomingContractor,
    icCompanyDocumentation,
    icEquipmentMaterial,
    icDeliveredServices,
};


